export default __webpack_public_path__ + "static/media/foto1.a7f3d684.jpg";